

import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Was It Good?</h1>
        <p>New </p>
      </header>
    </div>
  );
}

export default App;
